module.exports = __webpack_public_path__ + "static/vf-button-skirt.ce1ee199.svg";